import request from '@/utils/request'
import ENDPOINT from '@/config/endpoint'

export function getPlaceServices(params) {
  return request({
    url: ENDPOINT.PLACE_SERVICES,
    method: 'get',
    params
  })
}

export function createPlaceService(data) {
  return request({
    url: ENDPOINT.PLACE_SERVICES,
    method: 'post',
    data
  })
}

export function updatePlaceService(data) {
  return request({
    url: ENDPOINT.PLACE_SERVICES,
    method: 'patch',
    data
  })
}

export function deletePlaceService(params) {
  return request({
    url: ENDPOINT.PLACE_SERVICES,
    method: 'delete',
    params: typeof params === 'object' ? params : { id: params }
  })
}
